import React from "react";
import "./Loader.scss";

const Loader = () => {
  return (
    <div className="loader_bg">
      <span className="loader"></span>
    </div>
  );
};
export default Loader;
